import React from 'react';
import PropTypes from 'prop-types';
var NoMatches = function NoMatches(_ref) {
  var noMatchesFound = _ref.noMatchesFound,
    placeholder = _ref.placeholder;
  if (noMatchesFound) {
    return /*#__PURE__*/React.createElement("div", {
      className: "px-2.5 py-1 leading-7"
    }, /*#__PURE__*/React.createElement("span", null, placeholder));
  }
  return null;
};
NoMatches.propTypes = {
  noMatchesFound: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired
};
export default NoMatches;